import React from 'react';
import { Box } from '@mui/material';
import LoginCard from '../Home/components/LoginCard';

export default function LoginPage() {
  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 3,
      background: 'linear-gradient(135deg, #6B82D4 0%, #7C63D8 45%, #8B4FA8 100%)',
    }}>
      <Box sx={{ width: '100%', maxWidth: '460px' }}>
        <LoginCard />
      </Box>
    </Box>
  );
}
